<template>
  <div class="FBAprint">
    <div class="content">
      <div class="tabs">
        <el-tabs v-model="datas.type" type="card" @tab-click="handleClick">
          <el-tab-pane label="亚马逊FBA" name="FBA"></el-tab-pane>
          <el-tab-pane label="乐天" name="LETIAN"></el-tab-pane>
          <el-tab-pane label="雅虎" name="YAHU"></el-tab-pane>
          <el-tab-pane label="ZOZO" name="ZOZO"></el-tab-pane>
          <el-tab-pane label="其他" name="其他"></el-tab-pane>
        </el-tabs>
      </div>
      <!-- 标签数量： -->
      <div class="row">
        <div class="label">
          {{ $t("message.numberOfLabels") }}
          ：
        </div>
        <div class="val">
          <el-input v-model="datas.num" onfocus="this.select()" type="number"
            :placeholder="$t('message.numberOfLabels')"></el-input>
        </div>
      </div>
      <!-- 编码规则： -->
      <div class="row">
        <div class="label">
          {{ $t("message.codingRule") }}
          ：
        </div>
        <div class="val">
          <el-radio-group v-model="datas.code_type">
            <el-radio :label="'CODE128'" v-if="datas.type != 'ZOZO'">CODE128</el-radio>
            <el-radio :label="'EN13'" v-if="datas.type == 'LETIAN' || datas.type == '其他'">EN13</el-radio>
            <el-radio :label="'EN8'" v-if="datas.type == '其他'">EN8</el-radio>
            <el-radio :label="'CODE39'" v-if="datas.type == 'LETIAN' || datas.type == 'ZOZO'">CODE39</el-radio>
          </el-radio-group>
        </div>
      </div>
      <!-- 标签商品管理编码： -->
      <div class="row" v-if="datas.type != 'ZOZO'">
        <div class="label">
          AIN：
        </div>
        <div class="val">
          <!-- <el-input v-model="datas.goods_no" onfocus="this.select()" placeholder="'请输入ASIN码'
              " @paste="handlePaste"></el-input> -->
          <input type="text" v-model="datas.goods_no" @paste="handlePaste" class="goods_no" onfocus="this.select()"
            placeholder="请输入ASIN码">
        </div>
      </div>
      <!-- 标签显示内容： -->
      <div class="row">
        <div class="label">
          {{ $t("message.labelDisplayContent") }}：
        </div>
      </div>
      <div class="table" v-if="datas.type != 'ZOZO'">
        <ol>
          <!-- 显示顺序 -->
          <li>
            {{ $t("message.displaySequence") }}
          </li>
          <!-- 内容类别 -->
          <li>
            {{ $t("message.contentCategory") }}
          </li>
          <!-- 具体内容 -->
          <li class="flex15">
            {{ $t("message.specificContent") }}
          </li>
        </ol>
        <!-- 第一行 -->
        <ul>
          <!-- 显示顺序 -->
          <li>1行</li>
          <!-- 内容类别 -->
          <li>标签编码</li>
          <!-- 具体内容 -->
          <li class="flex15">
            <el-input v-model="datas.no" onfocus="this.select()" type="textarea"></el-input>
          </li>
        </ul>
        <!-- 第二行 -->
        <ul>
          <!-- 显示顺序 -->
          <li>2行</li>
          <!-- 内容类别 -->
          <li>标签文本描述</li>
          <!-- 具体内容 -->
          <li class="flex15">
            <el-input v-model="datas.text_line_one" onfocus="this.select()" type="textarea"></el-input>
          </li>
        </ul>
        <!-- 第三行 -->
        <ul v-if="datas.type == 'FBA' || datas.type == 'LETIAN'">
          <!-- 显示顺序 -->
          <li>3行</li>
          <!-- 内容类别 -->
          <li>标签文本描述2</li>
          <!-- 具体内容 -->
          <li class="flex15">
            <el-input v-model="datas.text_line_two" onfocus="this.select()" type="textarea"></el-input>
          </li>
        </ul>
        <!-- 第四行 -->
        <ul>
          <!-- 显示顺序 -->
          <li>4行</li>
          <!-- 内容类别 -->
          <li>标签文本描述3</li>
          <!-- 具体内容 -->
          <li class="flex15">
            <el-input v-model="datas.text_line_three" onfocus="this.select()" type="textarea"></el-input>
          </li>
        </ul>
      </div>
      <!-- 标签 ZOZO-->
      <div class="table" v-else>
        <ol>
          <!-- 显示顺序 -->
          <li>
            {{ $t("message.displaySequence") }}
          </li>
          <!-- 内容类别 -->
          <li>
            {{ $t("message.contentCategory") }}
          </li>
          <!-- 具体内容 -->
          <li class="flex15">
            {{ $t("message.specificContent") }}
          </li>
        </ol>
        <ul>
          <!-- 显示顺序 -->
          <li>1行</li>
          <!-- 内容类别 -->
          <li>ZOZO管理编码</li>
          <!-- 具体内容 -->
          <li class="flex15">
            <el-input v-model="datas.no" onfocus="this.select()" type="textarea"></el-input>
          </li>
        </ul>
        <!-- 第一行 -->
        <ul>
          <!-- 显示顺序 -->
          <li>2行</li>
          <!-- 内容类别 -->
          <li>商品名</li>
          <!-- 具体内容 -->
          <li class="flex15">
            <el-input v-model="datas.text_line_one" onfocus="this.select()" type="textarea"></el-input>
          </li>
        </ul>
        <!-- 第二行 -->
        <ul>
          <!-- 显示顺序 -->
          <li>3行</li>
          <!-- 内容类别 -->
          <li>zozo情报</li>
          <!-- 具体内容 -->
          <li class="flex15">
            <el-input v-model="datas.text_line_two" onfocus="this.select()" type="textarea"></el-input>
          </li>
        </ul>
        <!-- 第三行 -->
        <ul>
          <!-- 显示顺序 -->
          <li>4行</li>
          <!-- 内容类别 -->
          <li>自社情報</li>
          <!-- 具体内容 -->
          <li class="flex15">
            <el-input v-model="datas.text_line_three" onfocus="this.select()" type="textarea"></el-input>
          </li>
        </ul>
        <!-- 第四行 -->
        <ul>
          <!-- 显示顺序 -->
          <li>5行</li>
          <!-- 内容类别 -->
          <li>メーカー情報</li>
          <!-- 具体内容 -->
          <li class="flex15">
            <el-input v-model="datas.text_line_four" onfocus="this.select()"></el-input>
          </li>
        </ul>
      </div>
    </div>
    <div class="dialog-footer">
      <!-- 保存 -->
      <el-button type="primary" @click="pint">
        打印
      </el-button>
    </div>
    <!-- 标签打印 -->
    <div v-show="false">
      <div v-if="printTagData != null" ref="tabPrint">
        <tabPrint :printTagData="printTagData" :isExpress="''" />
      </div>
    </div>
  </div>
</template>
<script>
import tabPrint from "@/components/Printedsheet/tag/tabPrint.vue";
export default {
  components: { tabPrint },
  data() {
    return {
      printTagData: null,
      datas: {
        type: 'FBA',
        code_type: 'CODE128'
      },

    };
  },
  methods: {
    //切换type
    handleClick() {
      if (this.datas.type == 'FBA' || this.datas.type == 'YAHU') {
        this.datas.code_type = 'CODE128'
      } else if (this.datas.type == 'ZOZO') {
        this.datas.code_type = 'CODE39'
      }
    },
    // 打印
    pint() {
      this.printTagData = JSON.parse(JSON.stringify(this.datas))
      this.$nextTick(() => {
        this.$print(this.$refs.tabPrint);
        this.printTagData = null;

      });
    },

    // input粘贴事件
    handlePaste(e) {
      let list = e.clipboardData.getData('Text').split('\n')
      this.datas.no = list[1]
      this.datas.text_line_one = list[2]
      this.datas.text_line_two = list[3]
      this.datas.text_line_three = list[4]
      this.datas.text_line_four = list[5]
      setTimeout(() => {
        this.datas.goods_no = list[0]
        this.$forceUpdate()
      }, 500)


    },

  },

};
</script>
<style lang='scss' scoped>
.FBAprint {
  margin: 50px auto;
  width: 1200px;
}

/deep/.el-radio__input {
  transform: scale(1.5);
}

.content {
  margin: 0px 15px;

  .row {
    display: flex;
    margin-bottom: 20px;

    .label {
      flex: 1;
      line-height: 40px;
    }

    .val {
      flex: 3;
      line-height: 40px;
    }
  }

  .table {
    border: 1px solid #edeff4;

    ol {
      display: flex;
    }

    ul {
      display: flex;
      padding: 0;

      &:nth-last-child(1) {
        border: 0;
      }

      li {
        padding: 5px;
      }
    }

    li {
      border-right: 1px solid #edeff4;

      &:nth-last-child(1) {
        border: 0;
      }
    }

    .flex15 {
      flex: 1.5;
    }
  }

  /deep/.el-input {
    width: 80%;
  }

  /deep/.el-select {
    .el-input {
      width: 100%;
    }

    width: 80%;
  }

  .goods_no {
    width: 400px;
    height: 38px;
    padding: 0 10px;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
  }
}

.dialog-footer {
  margin: 30px 0;
  text-align: center;
}
</style>